import { ScreenSize } from 'glints-aries';
import styled from 'styled-components';

import SharedCompactJobCardList from 'src/components/Lists/CompactJobCardList';

export const CompactJobCardList = styled(SharedCompactJobCardList)`
  width: 100%;
  grid-gap: 12px 0;

  @media (min-width: ${ScreenSize.tablet}px) {
    grid-gap: 12px 16px;
  }

  @media (min-width: ${ScreenSize.desktopM}px) {
    grid-gap: 24px 32px;
    grid-template-columns: 1fr 1fr;
  }
`;
